module.exports = __webpack_public_path__ + "img/three.266075b5.jpg";